<template>
  <footer class="app-footer">
    <div class="container">
      <div class="footer-content">
        <img
          src="@/assets/images/astoc.png"
          alt="ASTOC Logo"
          class="footer-logo"
        />
        <div class="footer-contact">
          <span class="footer-phone">1533-0231</span>
        </div>
        <p class="footer-desc">
          건강하고 쾌적한 공간을 만드는 프리미엄 방역 솔루션
        </p>
      </div>
      <div class="copyright-bar">
        <p>&copy; 2010 ASTOC Inc. All Rights Reserved.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
  data() {
    return {
      currentYear: new Date().getFullYear()
    };
  }
};
</script>

<style scoped>
.app-footer {
  background: var(--bg-light);
  color: var(--text-light);
  padding-top: 4rem;
  text-align: center;
  margin-top: auto;
}
.footer-content {
  padding: 0 1rem 3rem;
}
.footer-logo {
  height: 30px;
  margin-bottom: 1rem;
  filter: invert(15%) sepia(20%) saturate(2500%) hue-rotate(180deg)
    brightness(90%) contrast(90%);
}
.footer-contact {
  font-weight: 700;
  font-size: 1.4rem;
  letter-spacing: 1px;
}
.footer-phone {
  color: #e53935;
}
.footer-desc {
  margin-bottom: 0.5rem;
  font-size: 1rem;
  color: var(--text-dark);
}
.copyright-bar {
  margin: 0;
  padding: 1.5rem 0;
  font-size: 0.9rem;
  color: var(--text-sub);
  background-color: var(--bg-white);
  border-top: 1px solid var(--border-color);
}
</style>
